/**
 * French profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: French
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 229
 */

export const FR = {
  "metadata": {
    "name": "French",
    "code": "fr",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 229
  },
  "words": [
    {
      "word": "abruti",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "abrut1",
        "abrutie"
      ],
      "case_sensitive": false,
      "context_notes": "Common insult meaning moron or stupid person",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "tiabru"
      ]
    },
    {
      "word": "andouille",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "and0uille"
      ],
      "case_sensitive": false,
      "context_notes": "Literally sausage, used as idiot insult",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "douillan"
      ]
    },
    {
      "word": "arnaqueur",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "arnaqu3ur",
        "arnaqueuse"
      ],
      "case_sensitive": false,
      "context_notes": "Scammer or cheat",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "keurarna"
      ]
    },
    {
      "word": "baiser",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "b@iser",
        "baiz3r"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck - historically meant to kiss but now vulgar",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "zébai"
      ]
    },
    {
      "word": "bander",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "b@nder",
        "band3r"
      ],
      "case_sensitive": false,
      "context_notes": "To have an erection",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "derban"
      ]
    },
    {
      "word": "babtou",
      "severity": 3,
      "categories": [
        "racial",
        "slurs"
      ],
      "variations": [
        "babt0u",
        "btou"
      ],
      "case_sensitive": false,
      "context_notes": "Reverse racism term for white person, from verlan 'toubab'",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "toubab"
      ]
    },
    {
      "word": "batard",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "bat@rd",
        "btard",
        "bâtard",
        "batarde",
        "bâtarde"
      ],
      "case_sensitive": false,
      "context_notes": "Bastard, moderately offensive general insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "tardba"
      ]
    },
    {
      "word": "beauf",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "be@uf",
        "b0f"
      ],
      "case_sensitive": false,
      "context_notes": "Redneck or boor, pejorative for uncultured person",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium"
      ],
      "verlan_forms": null
    },
    {
      "word": "bête",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "b3te",
        "bete"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid or dumb, relatively mild",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "teubé"
      ]
    },
    {
      "word": "bicot",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "ethnic"
      ],
      "variations": [
        "bic0t",
        "bcot"
      ],
      "case_sensitive": false,
      "context_notes": "Ethnic slur against Arabs/North Africans, very offensive",
      "target_type": "group",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "cotbi"
      ]
    },
    {
      "word": "bite",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "b1te",
        "byt3",
        "bitte"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for penis, very common in French slang",
      "target_type": "general",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "tebi"
      ]
    },
    {
      "word": "blaireau",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "bl@ireau",
        "blero"
      ],
      "case_sensitive": false,
      "context_notes": "Literally badger, means idiot",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "roblai"
      ]
    },
    {
      "word": "bordel",
      "severity": 2,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "bord3l",
        "brdl"
      ],
      "case_sensitive": false,
      "context_notes": "Originally 'brothel', now general exclamation of frustration",
      "target_type": "general",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "delbor"
      ]
    },
    {
      "word": "bouffon",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "b0uffon",
        "bouffonne"
      ],
      "case_sensitive": false,
      "context_notes": "Buffoon or clown, common insult",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "fonbou"
      ]
    },
    {
      "word": "bougnoule",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "ethnic"
      ],
      "variations": [
        "bougn0ule",
        "bgnoule"
      ],
      "case_sensitive": false,
      "context_notes": "Ethnic slur against North Africans, extremely offensive",
      "target_type": "group",
      "regions": [
        "france",
        "belgium"
      ],
      "verlan_forms": [
        "gnoulebo"
      ]
    },
    {
      "word": "bourré",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "b0urré",
        "bourrée"
      ],
      "case_sensitive": false,
      "context_notes": "Drunk or wasted",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "branlage",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "branl@ge"
      ],
      "case_sensitive": false,
      "context_notes": "Wanking, masturbation",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "branler",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "branl3r"
      ],
      "case_sensitive": false,
      "context_notes": "To wank or masturbate",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "lerbran"
      ]
    },
    {
      "word": "branlette",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "branl3tte"
      ],
      "case_sensitive": false,
      "context_notes": "Handjob or wanking",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "branleur",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "branl3ur",
        "branleuse"
      ],
      "case_sensitive": false,
      "context_notes": "Wanker or jerk-off",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "leurbran"
      ]
    },
    {
      "word": "broute-minou",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "broute minou"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy eater, vulgar sexual term",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "câlice",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "cal1ce",
        "clice",
        "kâlice",
        "calice"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec religious profanity referring to communion cup",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "calvaire",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "calv@ire",
        "klvr"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec religious profanity meaning calvary/hell",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "casse-couilles",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "casse couilles",
        "kass kouilles"
      ],
      "case_sensitive": false,
      "context_notes": "Ball-breaker, annoying person",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": null
    },
    {
      "word": "chatte",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "ch@tte",
        "chat"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy/female cat - context determines vulgarity",
      "target_type": "context_dependent",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "techa"
      ]
    },
    {
      "word": "chelou",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "chel0u",
        "chelou"
      ],
      "case_sensitive": false,
      "context_notes": "Sketchy or weird, verlan from louche",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "louche"
      ]
    },
    {
      "word": "chiasse",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "chi@sse"
      ],
      "case_sensitive": false,
      "context_notes": "Diarrhea or shit",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "chiant",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "chi@nt",
        "chiante"
      ],
      "case_sensitive": false,
      "context_notes": "Annoying, pain in the ass",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "chier",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "chi3r"
      ],
      "case_sensitive": false,
      "context_notes": "To shit",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "chiottes",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "chi0ttes"
      ],
      "case_sensitive": false,
      "context_notes": "Toilet or shitter",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "ciboire",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "cib0ire",
        "siboire"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec religious profanity - ciborium",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "clito",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "cl1to"
      ],
      "case_sensitive": false,
      "context_notes": "Clit, short for clitoris",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "clitoris",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "cl1toris"
      ],
      "case_sensitive": false,
      "context_notes": "Clitoris",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "con",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts",
        "slurs"
      ],
      "variations": [
        "c0n",
        "c@n",
        "conne"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for female genitalia, also general insult meaning 'idiot'",
      "target_type": "context_dependent",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "connard",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "con@rd",
        "conrd",
        "connr"
      ],
      "case_sensitive": false,
      "context_notes": "Common insult meaning 'asshole' or 'bastard'",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "nardcon"
      ]
    },
    {
      "word": "connasse",
      "severity": 3,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "conn@sse",
        "conasse"
      ],
      "case_sensitive": false,
      "context_notes": "Bitch or asshole - feminine form, very offensive",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": null
    },
    {
      "word": "connerie",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "conn3rie"
      ],
      "case_sensitive": false,
      "context_notes": "Bullshit or stupidity",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "couille",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "c0uille"
      ],
      "case_sensitive": false,
      "context_notes": "Testicle or ball, singular",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "yeukou"
      ]
    },
    {
      "word": "couilles",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "c0uilles"
      ],
      "case_sensitive": false,
      "context_notes": "Balls or testicles, can also mean courage in context",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "yeskou"
      ]
    },
    {
      "word": "couillon",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "c0uillon",
        "couillonne"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot or dumbass",
      "target_type": "individual",
      "regions": [
        "france",
        "switzerland"
      ],
      "verlan_forms": null
    },
    {
      "word": "crétin",
      "severity": 2,
      "categories": [
        "general",
        "slurs",
        "ableist"
      ],
      "variations": [
        "cr3tin",
        "crétine"
      ],
      "case_sensitive": false,
      "context_notes": "Cretin or moron",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "crisse",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "cr1sse",
        "kriss",
        "chris"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec religious profanity, from 'Christ'",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "cul",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "kul"
      ],
      "case_sensitive": false,
      "context_notes": "Ass or butt",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "débile",
      "severity": 2,
      "categories": [
        "general",
        "slurs",
        "ableist"
      ],
      "variations": [
        "d3bile",
        "debil"
      ],
      "case_sensitive": false,
      "context_notes": "Moron or retard - ableist term",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "dégueulasse",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "degueul@sse",
        "degueu"
      ],
      "case_sensitive": false,
      "context_notes": "Disgusting or filthy",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "ducon",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "duc0n"
      ],
      "case_sensitive": false,
      "context_notes": "Dumbass or idiot",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "emmerdant",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "emmerd@nt",
        "emmerdante"
      ],
      "case_sensitive": false,
      "context_notes": "Annoying",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "emmerder",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "emmerd3r"
      ],
      "case_sensitive": false,
      "context_notes": "To piss off or annoy",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "emmerdeur",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "emmerd3ur",
        "emmerdeuse"
      ],
      "case_sensitive": false,
      "context_notes": "Pain in the ass",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "enculé",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "encul3",
        "nclé",
        "enculer",
        "enculée"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar, homophobic undertones, very offensive",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "culéen"
      ]
    },
    {
      "word": "enculer",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "encul3r"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck in the ass, extremely vulgar",
      "target_type": "general",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": null
    },
    {
      "word": "enculeur",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "encul3ur",
        "enculeurs"
      ],
      "case_sensitive": false,
      "context_notes": "One who fucks in the ass",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "enfoiré",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "enf0iré",
        "nfr",
        "enfoirée"
      ],
      "case_sensitive": false,
      "context_notes": "Common French insult, roughly 'asshole' or 'jerk'",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "réenfoi"
      ]
    },
    {
      "word": "enflure",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "enflur3"
      ],
      "case_sensitive": false,
      "context_notes": "Literally swelling, used as asshole insult",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "espèce de con",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "espece de con"
      ],
      "case_sensitive": false,
      "context_notes": "You idiot - compound insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "étron",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "3tron",
        "etron"
      ],
      "case_sensitive": false,
      "context_notes": "Turd",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "face de cul",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "fass de cul"
      ],
      "case_sensitive": false,
      "context_notes": "Assface",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "faisnéant",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "fainéant"
      ],
      "case_sensitive": false,
      "context_notes": "Lazy bastard",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "fdp",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "f.d.p"
      ],
      "case_sensitive": false,
      "context_notes": "Abbreviation for fils de pute",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "fesse",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "f3sse"
      ],
      "case_sensitive": false,
      "context_notes": "Buttock or ass cheek",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "fif",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "f1f"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec homophobic slur - faggot",
      "target_type": "individual",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "fils de pute",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "fdp",
        "fils d put",
        "filsdepute"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a whore, very offensive compound insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "fion",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "fi0n"
      ],
      "case_sensitive": false,
      "context_notes": "Asshole or anus",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "folle",
      "severity": 3,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "f0lle"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur - queen or fairy",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium"
      ],
      "verlan_forms": null
    },
    {
      "word": "foutre",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "f0utre"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck or sperm - multipurpose profanity",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "fumier",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "fum13r"
      ],
      "case_sensitive": false,
      "context_notes": "Manure or bastard",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "garce",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "g@rce"
      ],
      "case_sensitive": false,
      "context_notes": "Bitch - feminine insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "glandeur",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "gland3ur",
        "glandeuse"
      ],
      "case_sensitive": false,
      "context_notes": "Slacker or lazy person",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "gland",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts",
        "slurs"
      ],
      "variations": [
        "gl@nd"
      ],
      "case_sensitive": false,
      "context_notes": "Dickhead or glans",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "gonzesse",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "gonz3sse"
      ],
      "case_sensitive": false,
      "context_notes": "Chick or broad - can be insulting",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "gouine",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "gou1ne",
        "gwine"
      ],
      "case_sensitive": false,
      "context_notes": "Lesbian slur, very offensive",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "neguoi"
      ]
    },
    {
      "word": "gourde",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "g0urde"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot or dumbass - feminine",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "gueule",
      "severity": 2,
      "categories": [
        "general",
        "body_parts"
      ],
      "variations": [
        "gu3ule"
      ],
      "case_sensitive": false,
      "context_notes": "Mouth or face - vulgar",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "gueux",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "gu3ux"
      ],
      "case_sensitive": false,
      "context_notes": "Beggar or wretch",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "imbécile",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "imb3cile",
        "imbecile"
      ],
      "case_sensitive": false,
      "context_notes": "Imbecile or idiot",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "idiot",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "idi0t",
        "idiote"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot - mild insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "je m'en branle",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "j'm'en branle"
      ],
      "case_sensitive": false,
      "context_notes": "I don't give a fuck - literally I masturbate about it",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "je m'en fous",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "j'm'en fous"
      ],
      "case_sensitive": false,
      "context_notes": "I don't give a damn",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "je t'emmerde",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "jt'emmerde"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck you - literally I shit on you",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "keuf",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "k3uf"
      ],
      "case_sensitive": false,
      "context_notes": "Cop - verlan from flic",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "flic"
      ]
    },
    {
      "word": "lopette",
      "severity": 3,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "lop3tte"
      ],
      "case_sensitive": false,
      "context_notes": "Wimp or sissy - homophobic undertones",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "mal baisé",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "mal baisée"
      ],
      "case_sensitive": false,
      "context_notes": "Sexually frustrated - literally badly fucked",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "malsain",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "mals@in",
        "malsaine"
      ],
      "case_sensitive": false,
      "context_notes": "Unhealthy or sick",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "maquereau",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "maquer3au"
      ],
      "case_sensitive": false,
      "context_notes": "Pimp",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "merde",
      "severity": 2,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "mrd",
        "m3rde",
        "merdre",
        "m*rde"
      ],
      "case_sensitive": false,
      "context_notes": "Universal French profanity, equivalent to 'shit'",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "drème"
      ]
    },
    {
      "word": "merdeux",
      "severity": 2,
      "categories": [
        "scatological",
        "slurs"
      ],
      "variations": [
        "merd3ux",
        "merdeuse"
      ],
      "case_sensitive": false,
      "context_notes": "Shitty or little shit",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "merdier",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "merd13r"
      ],
      "case_sensitive": false,
      "context_notes": "Shitshow or mess",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "meuf",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "m3uf"
      ],
      "case_sensitive": false,
      "context_notes": "Woman or chick - verlan from femme",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "femme"
      ]
    },
    {
      "word": "minable",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "min@ble"
      ],
      "case_sensitive": false,
      "context_notes": "Pathetic or worthless",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "minus",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "m1nus"
      ],
      "case_sensitive": false,
      "context_notes": "Loser or nobody",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "morpion",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "morpi0n"
      ],
      "case_sensitive": false,
      "context_notes": "Crab louse or little brat",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "morue",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "m0rue"
      ],
      "case_sensitive": false,
      "context_notes": "Cod or slut - insulting to women",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "morveux",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "morv3ux",
        "morveuse"
      ],
      "case_sensitive": false,
      "context_notes": "Snotty kid or brat",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "nase",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "naze",
        "n@se"
      ],
      "case_sensitive": false,
      "context_notes": "Broken, useless, or lame",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "nègre",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "racial"
      ],
      "variations": [
        "n3gre",
        "negr3",
        "négresse"
      ],
      "case_sensitive": false,
      "context_notes": "Racial slur, extremely offensive and inappropriate",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "nique ta mère",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "nique ta mere",
        "ntm"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother - very offensive",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "nique ta race",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "racial"
      ],
      "variations": [
        "nique ta rac",
        "ntr"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your race - hate speech",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "niquer",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "niqu3r"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "nul",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "nulle"
      ],
      "case_sensitive": false,
      "context_notes": "Useless, null, or lame - mild",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "ordure",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "0rdure",
        "@rdure"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone 'trash' or 'filth', moderately offensive",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "dureor"
      ]
    },
    {
      "word": "ostie",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "0stie",
        "@stie",
        "osti",
        "hostie"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec religious profanity referring to communion host",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "pauvre con",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pauv' con"
      ],
      "case_sensitive": false,
      "context_notes": "Poor idiot",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "pauvre type",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pauv' type"
      ],
      "case_sensitive": false,
      "context_notes": "Poor bastard or loser",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "pédale",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "p3dale"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur - faggot",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium"
      ],
      "verlan_forms": null
    },
    {
      "word": "pédé",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "p3dé",
        "ped3",
        "pd"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur, extremely offensive to LGBTQ+ community",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "dépé"
      ]
    },
    {
      "word": "pétasse",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "p3tasse",
        "petass"
      ],
      "case_sensitive": false,
      "context_notes": "Slut or bimbo - misogynistic",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "pignouf",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pign0uf"
      ],
      "case_sensitive": false,
      "context_notes": "Boor or jerk",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "pine",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "p1ne"
      ],
      "case_sensitive": false,
      "context_notes": "Dick or cock",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "plouc",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pl0uc"
      ],
      "case_sensitive": false,
      "context_notes": "Hick or redneck",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "pouffiasse",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "p0uffiasse",
        "poufiasse"
      ],
      "case_sensitive": false,
      "context_notes": "Cheap whore or skank - very offensive to women",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "pourriture",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pourr1ture"
      ],
      "case_sensitive": false,
      "context_notes": "Rot or scum",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "putain",
      "severity": 2,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "putin",
        "ptn",
        "put1",
        "pu74in",
        "p*tain"
      ],
      "case_sensitive": false,
      "context_notes": "Very common exclamation in France, less offensive than English equivalent",
      "target_type": "general",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "tainpu"
      ]
    },
    {
      "word": "pute",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "put3",
        "p*te",
        "pûte"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive when targeting women, equivalent to 'whore'",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": [
        "tepu"
      ]
    },
    {
      "word": "putois",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "put0is"
      ],
      "case_sensitive": false,
      "context_notes": "Skunk or stinker - insult",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "queue",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "qu3ue"
      ],
      "case_sensitive": false,
      "context_notes": "Dick or tail - vulgar in sexual context",
      "target_type": "context_dependent",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "queutard",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "queut@rd"
      ],
      "case_sensitive": false,
      "context_notes": "Horndog or sex-obsessed",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "raclure",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "r@clure"
      ],
      "case_sensitive": false,
      "context_notes": "Scum or scrapings",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "racaille",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "rac@ille"
      ],
      "case_sensitive": false,
      "context_notes": "Scum or rabble",
      "target_type": "group",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "raté",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "r@té",
        "ratée"
      ],
      "case_sensitive": false,
      "context_notes": "Loser or failure",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "rebeu",
      "severity": 2,
      "categories": [
        "ethnic"
      ],
      "variations": [
        "reb3u"
      ],
      "case_sensitive": false,
      "context_notes": "Arab - double verlan from beur, can be neutral or insulting",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "beur",
        "arabe"
      ]
    },
    {
      "word": "rinceuse",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "rinc3use"
      ],
      "case_sensitive": false,
      "context_notes": "Slut - literally rinser",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "rond",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "r0nd",
        "ronde"
      ],
      "case_sensitive": false,
      "context_notes": "Drunk - literally round",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "sacre",
      "severity": 1,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "s@cre",
        "sakré"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec mild religious expletive",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "saint-cimonac",
      "severity": 3,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "simonac",
        "cimonac"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec extreme religious curse",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "salaud",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "sal@ud",
        "salo"
      ],
      "case_sensitive": false,
      "context_notes": "Bastard or scumbag - masculine",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "sale",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "s@le"
      ],
      "case_sensitive": false,
      "context_notes": "Dirty or filthy - mild as standalone",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "sale con",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "sal con"
      ],
      "case_sensitive": false,
      "context_notes": "Dirty bastard",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "sale pute",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "sal pute"
      ],
      "case_sensitive": false,
      "context_notes": "Dirty whore - very offensive",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "salope",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "sal0pe",
        "s@lope",
        "slp"
      ],
      "case_sensitive": false,
      "context_notes": "Highly misogynistic slur, very offensive",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "lopesa"
      ]
    },
    {
      "word": "salopard",
      "severity": 3,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "sal0pard",
        "salprd"
      ],
      "case_sensitive": false,
      "context_notes": "Very offensive insult, combination of 'salope' and 'bâtard'",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "pardsal"
      ]
    },
    {
      "word": "saloperie",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "sal0perie"
      ],
      "case_sensitive": false,
      "context_notes": "Crap or filth",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "sauvage",
      "severity": 2,
      "categories": [
        "ethnic",
        "slurs"
      ],
      "variations": [
        "sauv@ge"
      ],
      "case_sensitive": false,
      "context_notes": "Savage - can be ethnic slur in certain contexts",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "siphonné",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "siphonn3",
        "siphonnée"
      ],
      "case_sensitive": false,
      "context_notes": "Crazy or nuts",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "sombre crétin",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "sombr crétin"
      ],
      "case_sensitive": false,
      "context_notes": "Complete moron",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "sombre idiot",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "sombr idiot"
      ],
      "case_sensitive": false,
      "context_notes": "Complete idiot",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "sous-merde",
      "severity": 2,
      "categories": [
        "scatological",
        "slurs"
      ],
      "variations": [
        "sous merde"
      ],
      "case_sensitive": false,
      "context_notes": "Sub-shit, lower than shit",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "suce",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "suc3"
      ],
      "case_sensitive": false,
      "context_notes": "Suck - imperative, sexual",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "sucer",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "suc3r"
      ],
      "case_sensitive": false,
      "context_notes": "To suck - sexual context",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "ta gueule",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "tagueule"
      ],
      "case_sensitive": false,
      "context_notes": "Shut up or shut your mouth",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "ta mère",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "ta mer"
      ],
      "case_sensitive": false,
      "context_notes": "Your mother - insult prefix",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "tabarnac",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "tabarn@c",
        "tbrnk",
        "tabarnak"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec religious profanity, equivalent to 'damn' or 'fuck'",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "tanche",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "t@nche"
      ],
      "case_sensitive": false,
      "context_notes": "Dumb or loser",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "tapette",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "tap3tte",
        "tptte"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur meaning 'faggot', very offensive",
      "target_type": "individual",
      "regions": [
        "france",
        "belgium",
        "switzerland"
      ],
      "verlan_forms": [
        "pettepa"
      ]
    },
    {
      "word": "tare",
      "severity": 2,
      "categories": [
        "general",
        "slurs",
        "ableist"
      ],
      "variations": [
        "t@re"
      ],
      "case_sensitive": false,
      "context_notes": "Defect or retard - ableist",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "taré",
      "severity": 2,
      "categories": [
        "general",
        "slurs",
        "ableist"
      ],
      "variations": [
        "t@ré",
        "tarée"
      ],
      "case_sensitive": false,
      "context_notes": "Retarded or crazy - ableist",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "tarlouze",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "tarl0uze"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur - faggot",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "taspé",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "tasp3"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot - verlan-ish",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "tepu",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "t3pu"
      ],
      "case_sensitive": false,
      "context_notes": "Whore - verlan from pute",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "pute"
      ]
    },
    {
      "word": "tête de con",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "tet de con"
      ],
      "case_sensitive": false,
      "context_notes": "Dickhead",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "tête de noeud",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "tet de neud",
        "tête de nœud"
      ],
      "case_sensitive": false,
      "context_notes": "Dickhead - literally knot head",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "teubé",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "teub3",
        "teube"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot or stupid - verlan from bête",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "bête"
      ]
    },
    {
      "word": "toqué",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "toqu3",
        "toquée"
      ],
      "case_sensitive": false,
      "context_notes": "Crazy or nuts",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "triso",
      "severity": 4,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "tris0"
      ],
      "case_sensitive": false,
      "context_notes": "Person with Down syndrome - extremely ableist",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "trisomique",
      "severity": 4,
      "categories": [
        "hate_speech",
        "ableist"
      ],
      "variations": [
        "trisomiqu3"
      ],
      "case_sensitive": false,
      "context_notes": "Person with trisomy - ableist when used as insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "troncher",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "tronch3r"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "trou du cul",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts",
        "slurs"
      ],
      "variations": [
        "trouducul",
        "trouduc"
      ],
      "case_sensitive": false,
      "context_notes": "Asshole - literally ass hole",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "truie",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "tru13"
      ],
      "case_sensitive": false,
      "context_notes": "Sow or fat woman - misogynistic",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "va chier",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "vachier"
      ],
      "case_sensitive": false,
      "context_notes": "Go shit or fuck off",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "va te faire enculer",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "va t faire enculer"
      ],
      "case_sensitive": false,
      "context_notes": "Go get fucked in the ass - extremely vulgar",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "va te faire foutre",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "va t faire foutre",
        "vtff"
      ],
      "case_sensitive": false,
      "context_notes": "Go fuck yourself",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "vaurien",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "vauri3n",
        "vaurienne"
      ],
      "case_sensitive": false,
      "context_notes": "Good-for-nothing or scoundrel",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "vermine",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "v3rmine"
      ],
      "case_sensitive": false,
      "context_notes": "Vermin or scum",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "vicieux",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "vici3ux",
        "vicieuse"
      ],
      "case_sensitive": false,
      "context_notes": "Pervert or deviant",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "vieille peau",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "vielle peau"
      ],
      "case_sensitive": false,
      "context_notes": "Old bag - literally old skin",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "youd",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "religious"
      ],
      "variations": [
        "y0ud"
      ],
      "case_sensitive": false,
      "context_notes": "Antisemitic verlan slur for Jew",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": [
        "juif"
      ]
    },
    {
      "word": "youpin",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "religious"
      ],
      "variations": [
        "youp1n",
        "ypn",
        "youpine"
      ],
      "case_sensitive": false,
      "context_notes": "Antisemitic slur, extremely offensive",
      "target_type": "group",
      "regions": [
        "france",
        "belgium"
      ],
      "verlan_forms": [
        "pinyou"
      ]
    },
    {
      "word": "zgueg",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "zguegg"
      ],
      "case_sensitive": false,
      "context_notes": "Dick - North African slang",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "zizi",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "z1zi"
      ],
      "case_sensitive": false,
      "context_notes": "Wiener or peepee - childish",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "zob",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "z0b"
      ],
      "case_sensitive": false,
      "context_notes": "Dick",
      "target_type": "general",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "baltringue",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "b@ltringue"
      ],
      "case_sensitive": false,
      "context_notes": "France - loser or worthless person",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "blédard",
      "severity": 2,
      "categories": [
        "ethnic",
        "slurs"
      ],
      "variations": [
        "bl3dard",
        "blédarde"
      ],
      "case_sensitive": false,
      "context_notes": "France - person from North African countryside, can be derogatory",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "bolos",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "bol0s",
        "boloss"
      ],
      "case_sensitive": false,
      "context_notes": "France - loser, verlan-derived",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "bougre",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "bougr3"
      ],
      "case_sensitive": false,
      "context_notes": "France - fellow or bugger, mildly vulgar",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "cassos",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "cass0s"
      ],
      "case_sensitive": false,
      "context_notes": "France - social case or loser",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "cave",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "c@ve"
      ],
      "case_sensitive": false,
      "context_notes": "France/Quebec - sucker or fool",
      "target_type": "individual",
      "regions": [
        "france",
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "charlot",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "charl0t"
      ],
      "case_sensitive": false,
      "context_notes": "France - clown or fool",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "clampin",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "clamp1n"
      ],
      "case_sensitive": false,
      "context_notes": "France - dawdler or slowpoke",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "cloche",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "cl0che"
      ],
      "case_sensitive": false,
      "context_notes": "France - bell or idiot",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "clodo",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "cl0do"
      ],
      "case_sensitive": false,
      "context_notes": "France - hobo or bum",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "crevard",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "crev@rd",
        "crevarde"
      ],
      "case_sensitive": false,
      "context_notes": "France - starving person or cheapskate",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "feignant",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "feign@nt",
        "feignasse"
      ],
      "case_sensitive": false,
      "context_notes": "France - lazy person",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "flemmard",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "flemm@rd",
        "flemmarde"
      ],
      "case_sensitive": false,
      "context_notes": "France - lazy person",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "gaupe",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "g@upe"
      ],
      "case_sensitive": false,
      "context_notes": "France - slut or slattern",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "gigolo",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "gig0lo"
      ],
      "case_sensitive": false,
      "context_notes": "France - male prostitute or kept man",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "verlan_forms": null
    },
    {
      "word": "mac",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "m@c"
      ],
      "case_sensitive": false,
      "context_notes": "France - pimp",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "mégère",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "m3gère",
        "megere"
      ],
      "case_sensitive": false,
      "context_notes": "France - shrew or harpy",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "olibrius",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "olibri0s"
      ],
      "case_sensitive": false,
      "context_notes": "France - show-off or character",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "pécore",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "p3core"
      ],
      "case_sensitive": false,
      "context_notes": "France - country bumpkin",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "raclure de bidet",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "raclur de bidet"
      ],
      "case_sensitive": false,
      "context_notes": "France - scum of the bidet, creative insult",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "tocard",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "toc@rd",
        "tocarde"
      ],
      "case_sensitive": false,
      "context_notes": "France - loser or worthless person",
      "target_type": "individual",
      "regions": [
        "france"
      ],
      "verlan_forms": null
    },
    {
      "word": "baptême",
      "severity": 1,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "bapt3me"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - baptism, mild curse",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "calvaire de marde",
      "severity": 3,
      "categories": [
        "religious",
        "scatological"
      ],
      "variations": [
        "calvair de marde"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - calvary of shit, compound curse",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "câlice de tabarnac",
      "severity": 3,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "calice de tabarnak"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - compound religious curse, very strong",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "ciboire de crisse",
      "severity": 3,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "ciboir de criss"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - compound religious curse",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "criss de cave",
      "severity": 2,
      "categories": [
        "religious",
        "slurs"
      ],
      "variations": [
        "cris de cave"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - Christ of idiot, compound insult",
      "target_type": "individual",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "enfant de chienne",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "enfan de chienne"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - son of a bitch",
      "target_type": "individual",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "maudit",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "m@udit"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - damned or cursed, mild",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "ostie de crisse",
      "severity": 3,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "osti de cris"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - host of Christ, compound curse",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "saint-ciboire",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "saint ciboire"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - holy ciborium",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "saint-sacrement",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "saint sacrement"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - holy sacrament",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "sacrament",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "sacr@ment"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - sacrament curse",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "tabarnak d'enfoiré",
      "severity": 3,
      "categories": [
        "religious",
        "slurs"
      ],
      "variations": [
        "tabarnac denfoiré"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - tabernacle of asshole, compound",
      "target_type": "individual",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "viarge",
      "severity": 2,
      "categories": [
        "religious",
        "general"
      ],
      "variations": [
        "vi@rge"
      ],
      "case_sensitive": false,
      "context_notes": "Quebec - virgin curse",
      "target_type": "general",
      "regions": [
        "quebec"
      ],
      "verlan_forms": null
    },
    {
      "word": "bobet",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "b0bet",
        "bobette"
      ],
      "case_sensitive": false,
      "context_notes": "Swiss - silly or naive person",
      "target_type": "individual",
      "regions": [
        "switzerland"
      ],
      "verlan_forms": null
    },
    {
      "word": "carabistouille",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "carabist0uille"
      ],
      "case_sensitive": false,
      "context_notes": "Belgian - nonsense",
      "target_type": "general",
      "regions": [
        "belgium"
      ],
      "verlan_forms": null
    },
    {
      "word": "drache",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "dr@che"
      ],
      "case_sensitive": false,
      "context_notes": "Belgian - heavy rain or mess",
      "target_type": "general",
      "regions": [
        "belgium"
      ],
      "verlan_forms": null
    },
    {
      "word": "tâche",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "tache"
      ],
      "case_sensitive": false,
      "context_notes": "Swiss/Belgian - stain or loser",
      "target_type": "individual",
      "regions": [
        "switzerland",
        "belgium"
      ],
      "verlan_forms": null
    }
  ]
} as const

export type FRType = typeof FR
